import { Contact } from '~api/address_book';

import { Fragment } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Button, MoreButton } from '@ingrid/luterkort-react';

import { DetailsDrawer as Drawer } from '~src/components/DetailsDrawer/DetailsDrawer';
import { RoleGuard } from '~src/components/RoleGuard/RoleGuard';
import { useTranslation } from '~src/i18n/use-translation';
import { AppRoute } from '~src/main/routes';

import { Menu } from './menu';

interface Props {
  contact?: Contact;
}

function AddressBookDrawerAction({ contact }: Props) {
  const { t } = useTranslation();

  if (!contact) {
    return;
  }

  return (
    <Fragment>
      <RoleGuard roles={['transport:edit']} withTooltip>
        <Button as={RouterLink} to={`${AppRoute.EDIT}/${contact.id}`}>
          {t('common.edit')}
        </Button>
      </RoleGuard>

      <Menu contact={contact} trigger={<MoreButton variant="secondary" />} />
    </Fragment>
  );
}

export function DetailsDrawer({ contact }: Props) {
  return (
    <Drawer
      actions={<AddressBookDrawerAction contact={contact} />}
      nodes={[
        <Drawer.Plain label="common.name" value={contact?.address?.name} key="name" />,
        <Drawer.SubRow label="common.addressLines" value={contact?.address?.address_lines} key="address-lines" />,
        <Drawer.Plain label="common.postalCode" value={contact?.address?.postal_code} key="postal-code" />,
        <Drawer.Plain label="common.city" value={contact?.address?.city} key="city" />,
        <Drawer.Plain label="common.country" value={contact?.address?.country} key="country" />,
        <Drawer.Plain label="common.doorCode" value={contact?.address?.door_code} key="door-code" />,
        <Drawer.Plain label="common.region" value={contact?.address?.region} key="region" />,
        <Drawer.Plain label="common.email" value={contact?.email} key="email" />,
        <Drawer.Plain label="common.phone" value={contact?.phone} key="phone" />,
        <Drawer.Date label="common.createdAt" value={contact?.created_at} time key="created" />,
        <Drawer.Date label="common.updatedAt" value={contact?.updated_at} time key="updated" />,
        <Drawer.Plain label="common.tags" value={contact?.notes} key="notes" />,
      ]}
    />
  );
}
